// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { Models } from "@hex-insights/app-modules";
import { TextField } from "@hex-insights/forms";
import { CourseAssessmentCategoryFormValidation, CourseAssessmentCategoryFormValues } from "../../FormUtilities";
import { BaseFieldProps } from "../shared";

/**
 * Generic props for fields of the CourseAssessmentCategory model.
 */
type FieldProps<
	K extends keyof CourseAssessmentCategoryFormValues.Base = keyof CourseAssessmentCategoryFormValues.Base,
> = BaseFieldProps<Pick<CourseAssessmentCategoryFormValues.Base, K>>;

/**
 * Field component for the `name` field of the CourseAssessmentCategory model.
 */
export function Name({ formState, instanceID, ...props }: FieldProps<"name"> & Partial<Models.FieldInstanceIDProps>) {
	Models.requireInstanceIDForUpdateForm(instanceID, formState.formType, "Name");
	const validateUnique = CourseAssessmentCategoryFormValidation.useUniqueNameValidator(instanceID);

	return <TextField formState={formState} name="name" scheduledValidation={validateUnique} {...props} />;
}
